import { useMutation } from '@tanstack/react-query';
import { apiClient } from '../apiClient';
import { getQueryKeyBase, MUTATION_KEYS } from '../queryClient';
import { updateCacheArray, updateCacheSingle, CACHE_ACTIONS } from '../cacheClient';
import { getQueryKey as getQueryKeyCriterias } from './useCriterias';
import { getQueryKey as getQueryKeyCriteriaById } from './useGetCriteriaById';

// Config
import { crudConfig } from '../../../conf/criteria';

// Hooks
import { useCriteriaStoreInit } from '../../state/criteria/hooks/useCriteriaStoreInit';

export const getMutationKey = getQueryKeyBase.bind(null, MUTATION_KEYS.CRITERIA);

export const useSaveCriteria = ({ sessionToken, criteriaId, onSuccessCb, onErrorCb, onSettledCb }) => {
    const Client = apiClient(crudConfig);
    const reInit = useCriteriaStoreInit();

    return useMutation({
        mutationKey: getMutationKey(criteriaId),
        mutationFn: ({ update }) => Client.update(sessionToken, update.criteriaId, update),
        onSuccess: (data, variables, context) => {
            updateCacheArray({
                queryKey: getQueryKeyCriterias(),
                action: CACHE_ACTIONS.UPDATE,
                primaryKey: crudConfig.primaryKey,
                data
            });
            updateCacheSingle({
                queryKey: getQueryKeyCriteriaById(criteriaId),
                action: CACHE_ACTIONS.UPDATE,
                primaryKey: crudConfig.primaryKey,
                data
            });
            reInit(data);
            onSuccessCb?.({ context: variables?.context });
        },
        onError: (error) => {
            console.log('Error', error);
            onErrorCb?.(error);
        },
        onSettled: () => {
            onSettledCb?.();
        },
        refetchOnWindowFocus: false
    });
};
